module.exports = __webpack_public_path__ + "img/P44-zh.8161bda2.png";